import { useEffect } from 'react';
import {
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getBuckets } from '../../../../../../../actions/rof-burns/rof-actions';

export default function BucketList({ projectKey }) {
    const dispatch = useDispatch();
    const buckets = useSelector(state => state.rofBurnsReducer.buckets)?.data;

    useEffect(() => {
        dispatch(getBuckets(projectKey))
    }, [dispatch, projectKey]);

    const bucketTableColumns = [
        'Id',
        'Name',
        'Volume',
        'Unit',
        'Created At',
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h4'>
                Bucket List
            </Typography>
            <Box>
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    {/* {loading ? <h1>Loading</h1> : */}
                    <Table aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                {bucketTableColumns.map((column, index) => (
                                    <TableCell align='left' key={index}>{column}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buckets
                                ?.map((bucket, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                        }}
                                    >
                                        <TableCell align='left'>{bucket.id}</TableCell>
                                        <TableCell align='left'>{bucket.name}</TableCell>
                                        <TableCell align='left'>{bucket.bucketVolume}</TableCell>
                                        <TableCell align='left'>{bucket.unit}</TableCell>
                                        <TableCell align='left'>
                                            {new Date(bucket.createdAt).toDateString()}
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}

